import type { ComponentPropsWithoutRef } from 'react';

import { LoadingState as Table } from '../Table';
import { LoadingState as Charts } from '../Charts';
import { Heading } from '@simplywallst/ui-core/next';
type Props = ComponentPropsWithoutRef<typeof Table>;

export const LoadingState = ({ currencyISO }: Props) => {
  return (
    <>
      <Charts />
      <div className="grid w-full max-w-screen-xl grid-cols-[max-content_max-content] justify-between gap-x2 justify-self-center p-x2 md:pt-0 lg:mb-x2 lg:p-0 lg:px-x3">
        <Heading
          as="h2"
          size="large"
          weight="strong"
          className="mb-x1 text-solid"
        >
          <span className="md:hidden">Detailed Returns</span>
          <span className="hidden md:inline">Detailed Returns Report</span>
        </Heading>
      </div>
      <div
        className="w-screen overflow-x-auto bg-p-white-100 xl:w-full xl:overflow-x-visible"
        data-theme="light"
      >
        <Table currencyISO={currencyISO} />
      </div>
    </>
  );
};
